/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_OnlineInputs */

const es_home_nexy_online = /** @type {(inputs: Home_Nexy_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En línea`)
};

const en_home_nexy_online = /** @type {(inputs: Home_Nexy_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

/**
* | output |
* | --- |
* | "Online" |
*
* @param {Home_Nexy_OnlineInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_online = /** @type {((inputs?: Home_Nexy_OnlineInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_OnlineInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_online(inputs)
	return en_home_nexy_online(inputs)
});
export { home_nexy_online as "home.nexy.online" }